import domReady from '@wordpress/dom-ready';
import { sprintf, _nx } from '@wordpress/i18n';

domReady(() => {
  const findstr = window.findstr;
  const countP = document.querySelector(
    '.block-listing__results-count[data-findstr-group="directories"]'
  );

  function adjustResultsCount(total) {
    const newText = sprintf(
      /* translators: %s is number of results */
      _nx('%s result', '%s results', total, 'results count', 'vtx'),
      total
    );
    countP.textContent = newText;
  }

  if (findstr && countP) {
    findstr.hooks.addAction(
      'searchResults',
      'icm-directories',
      (results, group) => {
        if ('directories' === group) {
          setTimeout(() => adjustResultsCount(results.totalHits), 100);
        }
      }
    );
  }
});
